import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';
import { jsmProjectSettingsUrl } from './common/index.tsx';

export const projectSettingsServicedeskAppsRoute: InvariantRoute = {
	name: 'project-settings-servicedesk-apps',
	path: `${jsmProjectSettingsUrl}/apps/:appId?`,
	exact: true,
};
